module.exports = __webpack_public_path__ + "img/dwnArrow-07.35615236.png";